// extracted by mini-css-extract-plugin
export default {"appContainer":"GxGTPFMHRntnlSEwbB95","children":"WGGrK6oS0hAXvK1YeNyF"};